import { render } from "./CustomerSetting.vue?vue&type=template&id=588262d1&scoped=true"
import script from "@/assets/js/customer.js?vue&type=script&lang=js&external"
export * from "@/assets/js/customer.js?vue&type=script&lang=js&external"

import "@/assets/css/customer.css?vue&type=style&index=0&id=588262d1&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588262d1"]])

export default __exports__